import { ChevronRight } from "@material-ui/icons";
import styled from "styled-components";
import { PrimaryButton } from "@loanbossinc/component-library";

export const StyledPrimaryButton = styled(PrimaryButton)`
  && {
    background: #005aa9;
    font-size: 13px;
    margin-left: 1em;
    white-space: nowrap;
    width: auto;
    margin-right: ${props => (props.isFromFile ? "1em" : 0)};
  }
`;

export const FieldWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
`;

export const FieldLeftContentWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const FieldIconWrapper = styled.div`
  && {
    padding: 0 1em;
  }
`;

export const FieldNameTypeWrapper = styled.div`
  && {
    display: flex;
    flex-direction: column;
  }
`;

export const FieldNameWrapper = styled.div`
  && {
    font-size: 14px;
    font-weight: 600;
  }
`;

export const FieldTypeWrapper = styled.div`
  && {
    color: #5f6368;
    font-size: 14px;
    font-weight: 400;
  }
`;

export const FieldRightContentWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    padding: 0 1em;
    text-align: right;
  }
`;

export const FieldLevelWrapper = styled.div`
  && {
    color: #5f6368;
    font-size: 14px;
    font-weight: 500;
    padding-right: 1em;
  }
`;

export const StyledChevronRight = styled(ChevronRight)`
  && {
    color: #005aa9;
  }
`;
